/* Arcanova pages on Shopify: the approved mockups' script (04-site/mockups/mockup.js: gallery, tiers, gifts, one
   row per piece, month picker, reviews filter, announcement, sticky bar) plus the store: tiers bound to their
   variants, the metal or month of each piece as line-item properties, the selenite plate and the birthstone charm
   in the same /cart/add.js call, the cart drawer with shipping protection ticked by default, the live countdown to
   the batch close and the arrival date. No dependency. */
(function () {
  var q = new URLSearchParams(location.search);
  var root = document.documentElement;
  if (q.has("sticky")) root.classList.add("cap");
  if (q.get("sticky") === "0") root.classList.add("nosticky");
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money in the visitor's currency (data-money = {{ 123456 | money }}) ---------- */
  var drawer = $("#ev-cart"), back = $("#evc-back");
  var MF = drawer && /1(\D?)234(\D)56/.test(drawer.dataset.money || "") ? drawer.dataset.money : "$1,234.56";
  var MP = MF.match(/1(\D?)234(\D)56/);
  function money(cents) {
    var i = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, MP[1]), f = cents % 100;
    return MF.replace(MP[0], i + (f ? MP[2] + (f < 10 ? "0" : "") + f : ""));
  }
  var rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;

  /* ---------- gallery: scroll-snap track, dots and counter on phones, numbered thumbs and arrows on desktop ---------- */
  var track = $("[data-track]");
  if (track) {
    var slides = $$(".ph", track), n = slides.length, cur = 0;
    var show = function (i) {
      cur = Math.max(0, Math.min(n - 1, i));
      var c = $("[data-count]"); if (c) c.textContent = cur + 1 + "/" + n;
      $$("[data-dots] span").forEach(function (d, k) { d.classList.toggle("on", k === cur); });
      $$(".th").forEach(function (t, k) { t.classList.toggle("on", k === cur); });
    };
    var go = function (i) { track.scrollTo({ left: Math.max(0, Math.min(n - 1, i)) * track.clientWidth, behavior: "smooth" }); };
    track.addEventListener("scroll", function () { show(Math.round(track.scrollLeft / track.clientWidth)); }, { passive: true });
    $$(".th").forEach(function (t) { t.addEventListener("click", function () { go(+t.dataset.go); }); });
    var p = $("[data-prev]"), nx = $("[data-next]");
    if (p) p.addEventListener("click", function () { go(cur - 1); });
    if (nx) nx.addEventListener("click", function () { go(cur + 1); });
  }

  /* ---------- tiers: price on the button and the sticky bar, the gifts tray, one row per piece ---------- */
  var tiers = $$(".tier"), tier = null;
  var pick = function (t) {
    tier = t;
    var k = +t.dataset.tier;
    tiers.forEach(function (x) { x.classList.toggle("sel", x === t); x.setAttribute("aria-pressed", x === t); });
    $$("[data-price]").forEach(function (e) { e.textContent = t.dataset.tp; });
    $$("[data-compare]").forEach(function (e) { e.textContent = t.dataset.tc; });
    var gh = $("[data-gh]");
    if (gh) gh.textContent = gh.getAttribute("data-h" + k);
    $$(".gift").forEach(function (g) {
      var need = +g.dataset.need, st = $(".g-state", g), on = need <= k;
      g.classList.toggle("locked", !on);
      if (st) st.textContent = on ? st.dataset.free : st.dataset.lock;
    });
    $$(".vrow").forEach(function (r) { r.hidden = +r.dataset.n > k; });
    hideErr();
  };
  tiers.forEach(function (t) { t.addEventListener("click", function () { pick(t); }); });
  if (tiers.length) {
    var want = +(q.get("tier") || 2);
    pick(tiers[Math.max(0, Math.min(tiers.length - 1, want - 1))]);
  }
  $$("[data-tierlink]").forEach(function (a) {
    a.addEventListener("click", function () { var t = tiers[+a.dataset.tierlink - 1]; if (t) pick(t); });
  });
  $$(".sw").forEach(function (sw) {
    $$(".pill", sw).forEach(function (b) { b.addEventListener("click", function () { $$(".pill", sw).forEach(function (x) { x.classList.toggle("on", x === b); }); }); });
  });

  /* ---------- the knot's month picker (a list with the heart crystal's colour) ---------- */
  document.addEventListener("click", function (e) {
    var opt = e.target.closest(".mp-opt"), btn = e.target.closest(".mp-btn");
    $$(".mp-list").forEach(function (l) { if (!btn || l.parentNode !== btn.parentNode) l.hidden = true; });
    if (btn) { var l = btn.parentNode.querySelector(".mp-list"); l.hidden = !l.hidden; btn.setAttribute("aria-expanded", String(!l.hidden)); }
    if (opt) {
      var pk = opt.closest(".mpick"), m = $(".mp-m", opt).textContent, c = $(".mp-c", opt).textContent;
      $(".mp-sel", pk).innerHTML = $(".mp-h", opt).outerHTML + m + " · " + c;
      pk.dataset.month = m + " (" + c + ")";
      hideErr();
    }
  });

  /* ---------- the birthstone charm: its month, asked once it is ticked ---------- */
  var MONTHS = $$(".mpick .mp-opt").slice(0, 12).map(function (o) { return $(".mp-m", o).textContent + " (" + $(".mp-c", o).textContent + ")"; });
  $$("label.bump[data-variant]").forEach(function (b) {
    if (!MONTHS.length) return;
    var s = document.createElement("select");
    s.className = "b-month"; s.setAttribute("aria-label", "Month of the charm"); s.hidden = true;
    s.innerHTML = '<option value="">Choose its month</option>' + MONTHS.map(function (m) { return "<option>" + m + "</option>"; }).join("");
    b.appendChild(s);
    var cb = $("input[type=checkbox]", b);
    cb.addEventListener("change", function () { s.hidden = !cb.checked; });
    s.addEventListener("click", function (e) { e.stopPropagation(); });
  });

  /* ---------- what goes in the cart ---------- */
  var errBox = null;
  function showErr(msg, el) {
    if (!errBox) { errBox = document.createElement("p"); errBox.className = "ev-err"; errBox.setAttribute("role", "alert"); }
    errBox.textContent = msg;
    var cta = $("[data-cta]"); if (cta) cta.parentNode.insertBefore(errBox, cta);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  function hideErr() { if (errBox && errBox.parentNode) errBox.parentNode.removeChild(errBox); }
  function buyItems() {
    if (!tier || !tier.dataset.variant) return null;
    var k = +tier.dataset.tier, props = {}, box = $(".variant[data-prop]"), missing = null;
    if (box) {
      var name = box.dataset.prop;
      $$(".vrow", box).forEach(function (r) {
        var i = +r.dataset.n; if (i > k) return;
        var pill = $(".pill.on", r), pk = $(".mpick", r), v = pill ? pill.textContent.trim() : pk ? pk.dataset.month : "";
        if (!v && !missing) missing = r;
        props[name + " " + i] = v || "";
      });
    }
    if (missing) { showErr("Choose a month for each knot.", missing); return null; }
    var items = [{ id: +tier.dataset.variant, quantity: 1, properties: props }];
    var up = $("label.upsell[data-variant]");
    if (up && $("input", up).checked && up.dataset.variant) items.push({ id: +up.dataset.variant, quantity: 1, properties: {} });
    var bump = $("label.bump[data-variant]");
    if (bump && $("input", bump).checked && bump.dataset.variant) {
      var sel = $(".b-month", bump);
      if (sel && !sel.value) { showErr("Choose the month of your birthstone charm.", bump); return null; }
      items.push({ id: +bump.dataset.variant, quantity: 1, properties: sel ? { Month: sel.value } : {} });
    }
    return items;
  }

  /* ---------- cart drawer ---------- */
  var PROT = drawer ? +drawer.dataset.prot : 0, protBox = $("#evc-prot input");
  var noProt = false; try { noProt = sessionStorage.getItem("ev_noprot") === "1"; } catch (e) {}
  if (protBox) protBox.checked = !noProt;
  function post(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  function getCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }); }
  // shipping protection follows the toggle: one line when the bag holds a piece and the toggle is on, none otherwise
  function syncProt(cart) {
    if (!PROT) return Promise.resolve(cart);
    var line = cart.items.filter(function (it) { return it.variant_id === PROT; })[0];
    var others = cart.items.filter(function (it) { return it.variant_id !== PROT; }).length;
    var want = others && !noProt ? 1 : 0, have = line ? line.quantity : 0;
    if (want === have) return Promise.resolve(cart);
    if (want && !have) return post("/cart/add.js", { items: [{ id: PROT, quantity: 1 }] }).then(getCart);
    return post("/cart/change.js", { id: line.key, quantity: want });
  }
  function openCart() { if (!drawer) return; drawer.classList.add("on"); drawer.setAttribute("aria-hidden", "false"); back.hidden = false; }
  function closeCart() { if (!drawer) return; drawer.classList.remove("on"); drawer.setAttribute("aria-hidden", "true"); back.hidden = true; }
  function renderCart(cart) {
    // /cart.js lists the latest first: shown oldest first, so the piece comes before its add-ons
    var lines = cart.items.filter(function (it) { return it.variant_id !== PROT; }).reverse();
    var count = lines.reduce(function (a, it) { return a + it.quantity; }, 0);
    $$(".cart .n").forEach(function (n) { n.textContent = count || ""; });
    if (!drawer) return;
    $("#evc-total").textContent = money(cart.total_price);
    var ds = drawer.dataset, free = Math.round(+ds.freeCents * rate);
    $("#evc-free").textContent = !count ? ds.msgEmpty : cart.total_price >= free ? ds.msgUnlocked : ds.msgLocked;
    var pr = $("#evc-prot"); if (pr) pr.hidden = !count;
    var box = $("#evc-lines");
    if (!lines.length) { box.innerHTML = '<p class="evc-empty">' + ds.msgCartEmpty + "</p>"; return; }
    box.innerHTML = lines.map(function (it) {
      var props = Object.keys(it.properties || {}).filter(function (k) { return k[0] !== "_" && it.properties[k]; })
        .map(function (k) { return k + ": " + it.properties[k]; }).join(" · ");
      var img = it.image ? '<img src="' + it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + 'width=160" alt="">' : "<span></span>";
      var was = it.original_line_price > it.final_line_price ? "<s>" + money(it.original_line_price) + "</s>" : "";
      var v = it.variant_title && it.variant_title !== "Default Title" ? it.variant_title : "";
      return '<div class="evc-line" data-key="' + it.key + '">' + img +
        "<div><b>" + it.product_title + '</b><span class="v">' + v + "</span>" +
        (props ? '<div class="props">' + props + "</div>" : "") +
        '<div><span class="evc-qty"><button type="button" data-q="' + (it.quantity - 1) + '" aria-label="Less">−</button>' + it.quantity +
        '<button type="button" data-q="' + (it.quantity + 1) + '" aria-label="More">+</button></span>' +
        '<button type="button" class="evc-rm" data-q="0">' + ds.msgRemove + "</button></div></div>" +
        '<div class="pr">' + money(it.final_line_price) + was + "</div></div>";
    }).join("");
  }
  function refresh() { return getCart().then(syncProt).then(renderCart); }
  function add(items, btn) {
    if (!items || !items.length) return;
    if (btn) btn.setAttribute("aria-busy", "true");
    return post("/cart/add.js", { items: items })
      .then(refresh).then(openCart)
      .catch(function () { location.href = "/cart/add?id=" + items[0].id + "&quantity=1"; })
      .then(function () { if (btn) btn.removeAttribute("aria-busy"); });
  }
  if (drawer) {
    $(".evc-x", drawer).addEventListener("click", closeCart);
    back.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closeMenu(); } });
    $("#evc-lines").addEventListener("click", function (e) {
      var b = e.target.closest("button[data-q]"); if (!b) return;
      post("/cart/change.js", { id: b.closest(".evc-line").dataset.key, quantity: +b.dataset.q }).then(syncProt).then(renderCart);
    });
    if (protBox) protBox.addEventListener("change", function () {
      noProt = !protBox.checked;
      try { sessionStorage.setItem("ev_noprot", noProt ? "1" : "0"); } catch (e) {}
      refresh();
    });
    $$("a.cart").forEach(function (a) {
      if (!$(".n", a)) a.insertAdjacentHTML("beforeend", '<span class="n"></span>');
      a.addEventListener("click", function (e) { e.preventDefault(); refresh().then(openCart); });
    });
    refresh();
  }
  var cta = $("[data-cta]");
  if (cta) cta.addEventListener("click", function (e) { e.preventDefault(); add(buyItems(), cta); });
  $$(".js-add").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      var items = buyItems();
      if (items) add(items, b); // a missing month scrolls the buy box into view (showErr)
    });
  });

  /* ---------- the menu panel (phone header) ---------- */
  var menu = $("#ev-menu");
  function closeMenu() { if (menu) menu.hidden = true; }
  $$("[data-menu]").forEach(function (b) { b.addEventListener("click", function () { if (menu) menu.hidden = !menu.hidden; }); });
  if (menu) $(".evc-x", menu).addEventListener("click", closeMenu);

  /* ---------- reviews filter ---------- */
  $$(".tagb").forEach(function (b) {
    b.addEventListener("click", function () {
      $$(".tagb").forEach(function (x) { x.classList.toggle("on", x === b); });
      $$(".rv").forEach(function (r) { r.hidden = b.dataset.tag !== "all" && r.dataset.tag !== b.dataset.tag; });
    });
  });

  /* ---------- announcement bar: the main line and the rotating line take turns ---------- */
  var rot = $(".ann .rot"), main = $(".ann .main");
  if (rot && main && !root.classList.contains("cap")) setInterval(function () { var m = rot.hidden; rot.hidden = !m; main.hidden = m; }, 4000);

  /* ---------- the batch countdown (offer-stack.md: the Hunter's Moon batch closes Nov 24, end of day in New York) ---------- */
  var END = Date.UTC(2026, 10, 25, 5, 0, 0);
  var cds = $$("[data-cd]");
  function tick() {
    var s = Math.max(0, Math.floor((END - Date.now()) / 1000)), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), x = s % 60;
    var pad = function (v) { return (v < 10 ? "0" : "") + v; };
    var t = (d ? d + "d " : "") + pad(h) + " : " + pad(m) + " : " + pad(x);
    cds.forEach(function (e) { e.textContent = t; });
  }
  if (cds.length) { tick(); setInterval(tick, 1000); }

  /* ---------- the arrival date: ships in 48 h, arrives in 7-12 days (the latest is shown) ---------- */
  var arrive = new Date(Date.now() + 12 * 86400000).toLocaleDateString("en-US", { month: "short", day: "numeric" });
  $$(".deliv").forEach(function (p) {
    var walk = document.createTreeWalker(p, NodeFilter.SHOW_TEXT), node;
    while ((node = walk.nextNode())) node.nodeValue = node.nodeValue.replace(/arrives by [A-Z][a-z]{2} \d{1,2}/, "arrives by " + arrive);
  });

  /* ---------- sticky bar: shows when the buy-box button leaves the screen ---------- */
  var sticky = $("[data-sticky]");
  if (sticky) {
    if (q.get("sticky") === "1") sticky.classList.add("show");
    else if (q.get("sticky") !== "0" && cta && "IntersectionObserver" in window) {
      new IntersectionObserver(function (e) { sticky.classList.toggle("show", !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(cta);
    }
  }
})();
